import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex space-x-5" }
const _hoisted_2 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import {useIonRouter} from "@ionic/vue";
import {computed, onMounted, PropType, ref} from "vue";
import ApiService from "@/services/api/apiService";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {AccountType} from "@/definitions/AccountType";
import {Observable, ObservableEvent} from "@/services/observable/Observable";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyIdImage',
  props: {
  user: {
    type: Object as PropType<UserBasicInformationInterface>,
    required: true
  }
},
  setup(__props) {



const ionRouter = useIonRouter()
const busy = ref(true)
const status = ref()

const photo = ref()

const props = __props

onMounted(async () => {
  status.value = await ApiService.User().getVerificationStatus()
  if (status.value.id_photo) photo.value = status.value.id_photo
  busy.value = false
})

const isImageUrl = computed(()=>{
  if (!photo.value) return
  return photo.value.includes('http')
})

const awaitingVerification = computed(()=>{
  if (!status.value) return
  return status.value.submitted_at
})

const choosePhoto = async () => {
  try {
    const image = await useCamera(CameraSource.Camera, CameraResultType.Base64)
    busy.value = true
    photo.value = undefined
    if (image && image.base64String) await ApiService.User().setIdPhoto(image.base64String)
    photo.value = image.base64String
    Observable.emit(ObservableEvent.VerificationStatusChanged)
  } catch (e) {
    busy.value = false
  } finally {
    busy.value = false
  }
}

const goBack = async () => {
  await ionRouter.back()
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: choosePhoto,
      class: "flex flex-col items-center space-y-4"
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle([
                  !isImageUrl.value ? `background-image: url('data:image/jpeg;base64,${photo.value}')` : `background-image: url('${photo.value}')`
              ]),
        class: _normalizeClass([{
              'border-2' : !photo.value
            }, "flex w-32 h-32 rounded-xl bg-cover bg-center border-brand-light-gray border-dashed"])
      }, [
        (!busy.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{ 'opacity-0' : photo.value}, "text-brand-light-gray m-auto text-center text-sm"])
            }, "Choose photo ", 2))
          : _createCommentVNode("", true),
        (busy.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 6)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2 my-auto" }, [
      _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Verification Photo"),
      _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "Please take a clear picture of you holding the same I.D as previously uploaded, making sure your face and I.D are clearly visible.")
    ], -1))
  ]))
}
}

})